import React, { useMemo } from 'react';
import useDynamicScript from './utils/useDynamicScript';
import loadComponent from './utils/loadComponent';
import { replaceStagingUrl } from "../../util/url";
const System = _ref => {
  let {
    system,
    fallback,
    ...props
  } = _ref;
  const {
    ready,
    failed
  } = useDynamicScript({
    url: system === null || system === void 0 ? void 0 : system.url,
    scope: system === null || system === void 0 ? void 0 : system.scope
  });
  const Component = useMemo(() => {
    // maybe return waitcursor instead
    if (!system || !ready || failed) {
      return null;
    }
    return /*#__PURE__*/React.lazy(loadComponent(system.scope, system.module, system.url, undefined, system.preventSingleton));

    /* eslint-disable react-hooks/exhaustive-deps */
  }, [system === null || system === void 0 ? void 0 : system.scope, ready, system === null || system === void 0 ? void 0 : system.url]);
  return Component ? /*#__PURE__*/React.createElement(React.Suspense, {
    fallback: fallback || ''
  }, /*#__PURE__*/React.createElement(Component, props)) : fallback;
};
const ModuleHost = _ref2 => {
  let {
    system,
    children = null,
    functions,
    // shallow data
    pages,
    isAdminModeActive,
    site,
    user,
    currentPage,
    device,
    language,
    parameters,
    customData,
    dialog,
    environment,
    preventStagingReplacement
  } = _ref2;
  // region initialData
  const initialData = {
    site,
    isAdminModeActive,
    pages,
    currentPage,
    device,
    language,
    parameters,
    customData,
    environment
  };
  if (user) {
    initialData.user = user;
  }
  if (dialog) {
    initialData.dialog = dialog;
  }
  // endregion

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "module-css"
  }), /*#__PURE__*/React.createElement(System, {
    system: {
      scope: system.scope,
      url: replaceStagingUrl(preventStagingReplacement, system.url, environment.buildEnvironment),
      module: system.module,
      preventSingleton: system.preventSingleton
    },
    data: initialData,
    functions: functions,
    fallback: children,
    isModule: true
  }));
};
export default ModuleHost;